import _defineProperty from "@babel/runtime/helpers/defineProperty";
class StoreImages {
  constructor() {
    _defineProperty(this, "removeDuplicated", (images, key) => {
      this.images = images.map(item => item[key]).map((item, index, final) => final.indexOf(item) === index && index).filter(item => images[item]).map(item => images[item]);
    });
    _defineProperty(this, "handleSelectedImage", imageId => {
      const index = this.images.findIndex(image => image.imageId === imageId);
      if (index !== -1) {
        this.setSelectedImage(index);
      }
    });
    _defineProperty(this, "setHandlers", ({
      toggleModal = this.toggleModal,
      setSelectedImage = this.setSelectedImage
    }) => {
      this.toggleModal = toggleModal;
      this.setSelectedImage = setSelectedImage;
    });
    _defineProperty(this, "addImages", (images, options = {}) => {
      if (!images.length) return this.images;
      const {
        pageBuilderID
      } = options;
      if (pageBuilderID !== this.id) {
        this.resetImages();
        this.id = pageBuilderID;
      }
      this.removeDuplicated(this.images.concat(images), 'imageId');
      return this.images;
    });
    this.images = [];
    this.id = null;
    this.toggleModal = () => {};
    this.setSelectedImage = () => {};
  }
  resetImages() {
    this.images = [];
  }
}
export default new StoreImages();
//# sourceMappingURL=StoreImages.js.map